import { render, staticRenderFns } from "./ShelfByOrder.vue?vue&type=template&id=d1c15d18&scoped=true"
import script from "./ShelfByOrder.vue?vue&type=script&lang=js"
export * from "./ShelfByOrder.vue?vue&type=script&lang=js"
import style0 from "./ShelfByOrder.vue?vue&type=style&index=0&id=d1c15d18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1c15d18",
  null
  
)

export default component.exports